<ng-container [formGroup]="editorForm">
    <h3
        class="form-header"
        mat-dialog-title
        i18n="@@e2a89de81f4e8ee3a2f86d2a8881fa56df5e5b1b"
        t="e2a89de81f4e8ee3a2f86d2a8881fa56df5e5b1b"
        >Add Material</h3
    >

    <div class="grid">
        <div fxLayout="column" fxLayoutGap="10px">
            <!-- Material Class-->
            <tsl-form-field fxFlex>
                <tsl-label
                    i18n="@@6b19d982e36bff8e6eccce2fd675c0a05230702a"
                    t="6b19d982e36bff8e6eccce2fd675c0a05230702a"
                    >Material Class</tsl-label
                >
                <tsl-select fullWidth required formControlName="class" (selectionChange)="onClassSelected($event)">
                    <tsl-option *ngFor="let item of materialClasses$ | async" [value]="item"
                        >{{ translate.get(item.description) }}
                    </tsl-option>
                </tsl-select>
            </tsl-form-field>
            <!-- Material Grade-->
            <tsl-form-field fxFlex>
                <tsl-label
                    i18n="@@d3b4c9f8a200632d59cb8a8f028063e71aadedd5"
                    t="d3b4c9f8a200632d59cb8a8f028063e71aadedd5"
                    >Material Grade</tsl-label
                >
                <tsl-select fullWidth required formControlName="grade">
                    <tsl-option *ngFor="let item of materialGrades$ | async" [value]="item"
                        >{{ item.description }}
                    </tsl-option>
                </tsl-select>
            </tsl-form-field>
        </div>
    </div>
    <div class="right">
        <button tsl-button size="small" color="black" outline (click)="onClose()" i18n="@@Cancel" t="Cancel"
            >Cancel</button
        >
        <button tsl-button size="small" color="blue" filled [disabled]="editorForm.invalid" (click)="onSave()" i18n
            >Add</button
        >
    </div>
</ng-container>
